import { Injectable } from '@angular/core';
import { BaseService } from '../../@core/services/base.service';
import { environment } from '../../../environments/environment.dev';
import { HttpClient } from '@angular/common/http';
import { IUser } from '../../@core/models/model';

export interface INotificationMeta {
    type: string,
    message: string,
    isRead: boolean,
}

export enum INotificationType {
    EMAIL = 'EMAIL',
    SMS = 'SMS',
    PUSH = 'PUSH',
    WEB = 'WEB',
    ALL = 'ALL',
    BANNER = 'BANNER'
}


export interface IBannerMeta {
    title: string;
    description: string;
    ctaText?: string;
    ctaLink?: string;
    data?: Record<string, string | number | boolean | object | Array<unknown>>;
    severity: 'info' | 'warning' | 'error';
}



export interface IMailMeta {
    subject: string,
    body: string,
    to: string,
    cc?: string,
    bcc?: string
    isDelivered: boolean
}

export const NOTIFICATION_EVENTS = {
    APPROVAL: {
        APPROVED: 'APPROVED',
        REJECTED: 'REJECTED',
        PENDING: 'PENDING',
        ADDED: 'ADDED',
    },
    SIGNATORY: {
        SIGNED: 'SIGNED',
        REJECTED: 'REJECTED',
        PENDING: 'PENDING'
    },
    SHARE: {
        SHARED: 'SHARED',
    },
    COMMENT: {
        COMMENTED: 'COMMENTED',
    },
    DOCUMENT: {
        GENERATED: 'GENERATED',
    },
    TRIAL: {
        EXPIRED_GRACE: 'TRIAL_EXPIRED_GRACE',
        INACTIVE_PENDING_DELETION: 'TRIAL_INACTIVE_PENDING_DELETION',
        PAYMENT_FAILURE_GRACE: 'PAYMENT_FAILURE_GRACE',
    },
    SUBSCRIPTION: {
        CANCELLED_GRACE: 'SUBSCRIPTION_CANCELLED_GRACE',
        INACTIVE_PENDING_DELETION: 'SUBSCRIPTION_INACTIVE_PENDING_DELETION',
    }
}

export enum NOTIFICATION_STATUS {
    PENDING = 'PENDING',
    SENT = 'SENT',
    FAILED = 'FAILED',
    DELIVERED = 'DELIVERED',
    EXPIRED = 'EXPIRED'
}
export enum NOTIFICATION_PRIORITY {
    HIGH = 'HIGH',
    MEDIUM = 'MEDIUM',
    LOW = 'LOW'
}

export enum NotificationActionType {
    CLAUSE_EXTRACTION_RETRY = 'CLAUSE_EXTRACTION_RETRY',
}

export interface INotification extends Document {
    readonly _id: string;
    org: string,
    user: IUser | string,
    meta: INotificationMeta,
    type: INotificationType,
    module: string,
    subModule: string,
    event: {
        type: string,
        data: object | any,
        action: string,
        triggeredBy: IUser
    },
    status?: NOTIFICATION_STATUS;
    priority?: string;
    createdAt?: Date;
}

export interface IBannerNotification extends Omit<INotification, 'meta'> {
    meta: IBannerMeta;
}


@Injectable({ providedIn: 'root' })
export class NotificationService extends BaseService {

    apiUrl = environment.apiUrl + '/notifications';


    constructor(
        protected override http: HttpClient
    ) {
        super(http);
    }

    getNotifications(filters?: { skip?: number, limit?: number }) {
        return this.post<INotification[]>(this.apiUrl + '/fetch-notifications', filters);
    }

    getBanners() {
        return this.get<IBannerNotification[]>(this.apiUrl + '/fetch-banners');
    }

    getNotificationsCount() {
        return this.get<number>(this.apiUrl + '/fetch-notifications-count');
    }

    markRead(notificationId: string) {
        return this.post(this.apiUrl + '/mark-as-read/' + notificationId, {});
    }

    markAllAsRead() {
        return this.put(this.apiUrl + '/mark-all-as-read', {});
    }
}